require('new_design/desktop/camps/show/direct_contacts');
